/**
 * ExpansionPanel
 * @module components/ExpansionPanel
 */

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from 'context/localization.context';
import { ShowMore, Expander, Link, Div } from './ExpansionPanel.styles';
import Icon from '../Icon';

const ExpansionPanel = ({ toggleExpansionPanel, expanded, className }) => {
	const { t } = useContext(LocalizationContext);

	return (
		<Link
			role="button"
			href="#related-links"
			aria-expanded={expanded}
			onClick={(e) => {
				e.preventDefault();
				toggleExpansionPanel();
			}}
			className={className}
		>
			<Expander>
				<Div>
					<ShowMore>
						{expanded
							? t('shared/expansionpanel/showless')
							: t('shared/expansionpanel/showmore')}
					</ShowMore>
					<Icon
						icon="chevron"
						className="ml-2"
						direction={expanded ? 'down' : 'up'}
						size={0.75}
					/>
				</Div>
			</Expander>
		</Link>
	);
};

ExpansionPanel.propTypes = {
	toggleExpansionPanel: PropTypes.func,
	expanded: PropTypes.bool,
};

export default ExpansionPanel;
